class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.form.addEventListener('submit', this.onBudgetSubmit.bind(this), true);
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  getBudgetSearchUrl() {
    const config = document.querySelector('script[data-budget-currency]');
    if (config?.dataset.budgetCurrency !== 'CLP') return null;
    const query = this.input.value.trim().replace(/^\$\s*/, '');
    if (!/^(?:\d{4,9}|\d{1,3}(?:\.\d{3}){1,2})$/.test(query)) return null;
    const amount = Number(query.replace(/\./g, ''));
    if (!Number.isSafeInteger(amount) || amount < 1000) return null;
    const url = new URL(config.dataset.budgetCollectionUrl, window.location.origin);
    url.searchParams.set('filter.v.price.lte', String(amount));
    url.searchParams.set('sort_by', 'price-descending');
    return url;
  }

  onBudgetSubmit(event) {
    const url = this.getBudgetSearchUrl();
    if (!url) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(url.href);
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
